import ACTIONS from "./actions";

export const initialState = {
  status: {
    isLoading: true,
    isError: false,
    data: [],
  },
};

function fetchLatestLogsReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_LATEST_LOGS_INIT: {
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    }

    case ACTIONS.FETCH_LATEST_LOGS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    }

    case ACTIONS.FETCH_LATEST_LOGS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    }

    default:
      return state;
  }
}

export default fetchLatestLogsReducer;
